qtee.customDesign = window.qtee.customDesign || {};

/** Layout */
qtee.customDesign.Layout = Backbone.Marionette.LayoutView.extend({
	template: '/custom-design/templates/layout',
	className: 'customDesign',
	regions: {
		headerRegion: '#customDesignHeader',
		bodyRegion: '#customDesignBody',
		footerRegion: '#customDesignFooter'
	},
	onBeforeShow: function () {

		this.showChildView('headerRegion', new qtee.customDesign.HeaderView({ model: this.model }));
		this.showChildView(
			'bodyRegion',
			new qtee.customDesign.MainView({
				model: this.model,
				noAutoSave: this.options.noAutoSave,
				isFavorite: this.options.isFavorite
			})
		);

	}
});
